import AWS from 'aws-sdk';

let returnUrlImage = (path) => {
  const credentials = {
    accessKeyId: process.env.VUE_APP_S3_KEY,
    secretAccessKey: process.env.VUE_APP_S3_SECRET,
  };
  AWS.config.update({
    credentials: credentials,
    region: process.env.VUE_APP_S3_REGION,
  });
  const s3 = new AWS.S3();
  const presignedGETURL = s3.getSignedUrl('getObject', {
    Bucket: process.env.VUE_APP_S3_BUCKET,
    Key: path,
    Expires: 300,
  });
  return presignedGETURL;
};

export default {
  returnUrlImage,
};
